import React from 'react';
import { Box, Typography } from '@mui/material';
import moment from 'moment';
import { classes } from '../../document-management/documents/utils';
import { lightPalette } from '../../../../theme';

const UserName = (params) => {
  const FIRST_NAME = params?.data?.firstName;
  const LAST_NAME = params?.data?.lastName;

  if (params?.data) {
    return (
      <Typography
        variant="body1"
        color={lightPalette.lunarBase.main}
        fontWeight="400"
      >
        {FIRST_NAME && LAST_NAME ? `${FIRST_NAME} ${LAST_NAME}` : '-'}
      </Typography>
    );
  }
};

const UserRole = (params) => {
  if (params?.data) {
    if (params?.data?.role) {
      return (
        <Typography variant="body1" fontWeight={400}>
          {params?.data?.role}
        </Typography>
      );
    }
    return (
      <Typography variant="body1" fontWeight={400}>
        -
      </Typography>
    );
  }
};

const organizationName = (params) => {
  if (params?.data) {
    if (params?.data?.organizationDetails?.organizationName !== undefined) {
      return (
        <Typography variant="body1" fontWeight={400}>
          {params?.data?.organizationDetails?.organizationName}
        </Typography>
      );
    }
    return (
      <Typography variant="body1" fontWeight={400}>
        -
      </Typography>
    );
  }
};

const eventType = (params) => {
  if (params?.data) {
    if (params?.data?.eventType !== undefined) {
      return (
        <Typography variant="body1" fontWeight={400}>
          {params?.data?.eventType}
        </Typography>
      );
    }
    return (
      <Typography variant="body1" fontWeight={400}>
        -
      </Typography>
    );
  }
};

const messageCell = (params) => {
  const { data } = params;
  if (data) {
    const { message } = data;
    if (typeof message !== 'object' && message) {
      return (
        <Typography variant="body1" fontWeight={400}>
          {message}
        </Typography>
      );
    }
    return (
      <Typography variant="body1" fontWeight={400}>
        -
      </Typography>
    );
  }
};

const timestampCell = (params) => {
  const value = params?.data?.timestamp;
  const formattedDate = moment.utc(value).local().format('DD-MM-YYYY HH:mm:ss');

  if (params?.data?.timestamp) {
    return (
      <Box>
        {value !== undefined && value !== null ? (
          <Typography variant="body1" fontWeight="400">
            {formattedDate}
          </Typography>
        ) : (
          <Box className={classes.dateValueBox}>
            <Typography>-</Typography>
          </Box>
        )}
      </Box>
    );
  }
};

const activityHistoryColumnDef = (
  gridSettingData,
  gridKey,
  // setCustomFilterValue,
  customFilterValue,
  screenWidth,
) => {
  const isSmallScreen = screenWidth < 600;

  return [
    {
      headerName: 'User Name',
      field: 'name',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      minWidth: isSmallScreen ? 150 : 200,
      maxWidth: isSmallScreen ? 200 : 300,
      resizable: false,
      cellRenderer: UserName,
      pinned: isSmallScreen ? '' : 'left',
      lockPinned: true,
      lockPosition: true,
      filter: true,
      suppressMenu: true,
      type: 'text',
      filterParams: {
        filterOptions: ['contains'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
      },
      hide: false,
    },
    {
      headerName: 'Organization Name',
      field: 'organization_name',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      minWidth: isSmallScreen ? 200 : 250,
      maxWidth: isSmallScreen ? 250 : 300,
      cellRenderer: organizationName,
      filter: true,
      suppressMenu: true,
      type: 'text',
      filterParams: {
        filterOptions: ['contains'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
      },
      hide: true,
    },
    {
      headerName: 'Event Type',
      field: 'event_type',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      minWidth: isSmallScreen ? 120 : 150,
      maxWidth: isSmallScreen ? 150 : 200,
      resizable: true,
      cellRenderer: eventType,
      filter: true,
      suppressMenu: true,
      type: 'text',
      filterParams: {
        filterOptions: ['contains'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
      },
      hide: false,
    },
    {
      headerName: 'Message',
      field: 'message',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      minWidth: isSmallScreen ? 250 : 300,
      maxWidth: isSmallScreen ? 300 : 350,
      resizable: true,
      cellRenderer: messageCell,
      filter: true,
      suppressMenu: true,
      type: 'text',
      filterParams: {
        filterOptions: ['contains'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
      },
    },
    {
      headerName: 'Role',
      field: 'role',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
        customFilterValue,
      },
      // filter: 'CustomDropdownFilter',
      type: 'checkBox',
      cellRenderer: UserRole,
      minWidth: isSmallScreen ? 100 : 120,
      maxWidth: isSmallScreen ? 150 : 220,
      sortable: true,
      filterParams: {
        // setCustomFilterValue,
        customFilterValue,
        gridKey,
      },
    },
    {
      headerName: 'Time',
      field: 'timestamp',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      minWidth: isSmallScreen ? 120 : 150,
      maxWidth: isSmallScreen ? 200 : 250,
      cellRenderer: timestampCell,
      filter: 'agDateColumnFilter',
      type: 'date',
      suppressMenu: true, // Hides the filter icon
      filterParams: {
        filterOptions: ['inRange'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
        // minValidDate: superAdminOrSuperManager ? null : formattedMinDate,
        // maxValidDate: todayString,
        comparator: (filterDate, cellValue) => {
          const cellDate = new Date(cellValue);
          if (cellDate < filterDate) return -1;
          if (cellDate > filterDate) return 1;
          return 0;
        },
      },
    },
  ];
};

export default activityHistoryColumnDef;
